var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

import styled, { css } from "styled-components";
import { buttonTertiaryStyles } from "@nib-components/theme";
import BaseButton, { buttonPropTypes, buttonDefaultProps, sizeStyling, fullWidthStyling } from "../BaseButton"; // eslint-disable-next-line no-unused-vars

export var TertiaryButton = styled(BaseButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  ", "\n\n  ", "\n\n  ", "\n\n    \n    \n    ", "\n    ", "\n"])), function (props) {
  return buttonTertiaryStyles(props)[props.color].normal;
}, function (props) {
  return props.selected && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n      ", ";\n    "])), buttonTertiaryStyles(props)[props.color].selected);
}, function (props) {
  return props.disabled && css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      ", ";\n    "])), buttonTertiaryStyles(props)[props.color].disabled);
}, function (props) {
  return props && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n      &:disabled {\n        ", ";\n      }\n    "])), buttonTertiaryStyles(props)[props.color].disabled);
}, sizeStyling, fullWidthStyling);
TertiaryButton.displayName = "TertiaryButton";
TertiaryButton.propTypes = buttonPropTypes;
TertiaryButton.defaultProps = buttonDefaultProps;